import { CalculatorLineItem } from '@/modules/tax/models/calculators/CalculatorLineItem';
import { Calculator } from '@/modules/tax/models/calculators/Calculator';

export class ProbateCalculator extends Calculator {
  lineItems: Relationship<CalculatorLineItem[]> | null;

  constructor(model: Partial<ProbateCalculator> = {}) {
    super(model);

    this.lineItems = CalculatorLineItem.mapModelsOrNull(model.lineItems);
  }
}
